import { Component, OnInit } from '@angular/core';
import { SubHeaderData } from 'src/app/models/sub-header-data';
import { IceDatabaseDetail } from '../../models/ice-database.model';
import { IceDatabaseService } from 'src/app/services/ice-database.service';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'app-ice-database',
    templateUrl: './ice-database.component.html',
    styleUrls: ['./ice-database.component.scss'],
})
export class IceDatabaseComponent implements OnInit {
    subHeaderData: SubHeaderData;
    databaseDetails: IceDatabaseDetail[] = this.iceDatabaseService.databaseDetails;

    constructor(private iceDatabaseService: IceDatabaseService,
             private translocoService: TranslocoService) {}

    ngOnInit(): void {
        this.subHeaderData = this.setSubHeaderValues();
    }

    setSubHeaderValues(): SubHeaderData {
        let headerData = new SubHeaderData();
        headerData.displayText = this.translocoService.translate('HOME_PAGE.HEADER.INFORMATE_DROPDOWN.LINK.ICE_DATABASE');
        headerData.disableActions = true;
        headerData.defaultImageSrc = '../../../../../assets/media/logos/database-black.png';
        headerData.mouseOverImageSrc = '../../../../../assets/media/logos/database-black.png';
        return headerData;
    }
}
